/// <amd-module name="VSS/Redux/Deprecated/HubViewState/HubViewStateActions" />
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";
import { IFilterState } from "VSSUI/Utilities/Filter";
import { IViewOptionsValues } from "VSSUI/Utilities/ViewOptions";

export const enum HubViewStateActionTypes {
    Initialize = "HubViewState/Initialize",
    CurrentPivotChanged = "HubViewState/CurrentPivotChanged",
    FilterStateChanged = "HubViewState/FilterStateChanged",
    ViewOptionsChanged = "HubViewState/ViewOptionsChanged"
}

export const HubViewStateActions = {
    initialize: (pivotKey: string, filterState: IFilterState, viewOptions: IViewOptionsValues) =>
        createAction(HubViewStateActionTypes.Initialize, { pivotKey, filterState, viewOptions }),
    /** Fired when the current pivot changes */
    currentPivotChanged: (pivotKey: string) => createAction(HubViewStateActionTypes.CurrentPivotChanged, pivotKey),
    /** Fired when the filter state changes */
    filterStateChanged: (filterState: IFilterState) => createAction(HubViewStateActionTypes.FilterStateChanged, filterState),
    /** Fired when the view options change */
    viewOptionsChanged: (changedOptions: IViewOptionsValues) => createAction(HubViewStateActionTypes.ViewOptionsChanged, changedOptions)
};

export type HubViewStateActions = ActionsUnion<typeof HubViewStateActions>;
